// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/downloadCenter',
    name: 'DownloadCenter',
    component: layout,
    redirect: '/downloadCenter/index',
    meta: {
      title: '下载中心',
      icon: 'i-menu:download',
      i18Key: 'router.user.downloadCenter.title',
      roles: [1]
    },
    sort: 54,
    children: [
      {
        path: 'index',
        name: 'DownloadCenterIndex',
        component: () => import('@/views/Sentiment/DownloadCenter.vue'),
        meta: {
          title: '下载中心',
          icon: 'download',
          iconIsComponent: true,
          i18Key: 'router.user.downloadCenter.index',
          roles: [1],
          headerConditions: [],
          isAdvanced: false
        }
      }
    ]
  }
]
export default routes
